







import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { PieChartData } from '@/model/dashboard/PieChartData'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
}

export default Vue.extend({
  name: 'PieChart',

  props: {
    pieChartLabel: String,
    pieChartData: {
      type: Array as () => Array<PieChartData>
    }
  },

  data (): ComponentData {
    return {
      chart: undefined
    }
  },

  mounted () {
    //@ts-ignore
    let chart = am4core.create(this.$refs.pieChart, am4charts.PieChart)

    // Add data
    chart.data = this.pieChartData

    // Add and configure Series
    let pieSeries = chart.series.push(new am4charts.PieSeries())
    pieSeries.dataFields.value = 'value'
    pieSeries.dataFields.category = 'name'

    // Let's cut a hole in our Pie chart the size of 40% the radius
    chart.innerRadius = am4core.percent(40)

    // Disable ticks and labels
    pieSeries.labels.template.disabled = true
    pieSeries.ticks.template.disabled = true
    pieSeries.alignLabels = false
    am4core.percent(-40)
    pieSeries.slices.template.fillOpacity = 1

    let hs = pieSeries.slices.template.states.getKey('hover')
    hs.properties.scale = 1
    hs.properties.fillOpacity = 0.5

    // Add a legend
    chart.legend = new am4charts.Legend()

    pieSeries.colors.list = [
      am4core.color('#43A047'),
      am4core.color('#BBDEFB'),
      am4core.color('#FFFF00'),
    ]

    this.chart = chart
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }

})
